export default {
  common: {
    clearAll: 'Cancella Tutto',
    restart: 'Riavviare'
  },
  download: {
    bodyText: 'Fai clic su un link di Download qui sotto per scaricare %{products}',
    bothProducts: 'PlayBase e/o Nexus',
    bodyTextFromAcceptInvitation:
      'Il processo richiederà del tempo. Nel frattempo, puoi continuare a utilizzare Metrica Sports come al solito.',
    bodyTextFromDeclineInvitation:
      "Hai rifiutato l'invito! Fai clic su un link di Download qui sotto per scaricare %{products}",
    bodyTextFromTrial:
      'Benvenuto al Tuo Periodo di Prova! Controlla la tua email registrata per un link di verifica (controlla nella cartella dello spam).',
    bodyTitle: 'Scaricare',
    bodyTitleFromAcceptInvitation: 'Stiamo Cambiando Il Tuo Account',
    bodyTitleFromDeclineInvitation: 'Invitazione Rifiutata',
    bodyTitleFromTrial: 'Registrazione completata',
    play2: {
      description:
        'Metrica PlayBase è uno strumento di analisi intuitivo progettato per allenatori dilettanti e prosumer, piccoli club e analisti indipendenti. Semplifica il processo di valutazione delle prestazioni, rendendolo accessibile a tutti.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        "Metrica Nexus è pensato per analisti e allenatori d'élite che cercano informazioni complete sulle prestazioni. Con strumenti avanzati a portata di mano, puoi migliorare le strategie della squadra e ottenere successo.",
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Grazie per esserti registrato su Metrica Sports! Per iniziare con la tua prova, scarica %{products}.'
  },
  error: {
    restart: 'Sembra che tu stia cercando di entrare in qualcosa che stiamo ancora sviluppando...',
    tryAgainMsg:
      "Si prega di riprovare, se l'errore continua, contattare il team di supporto di Metrica Sports."
  },
  verifyEmail: {
    generateLink: 'Generare un nuovo link accedendo a Play',
    readyToLogin: 'Sei pronto per accedere a Play',
    successfully: 'Email verificata con successo',
    unsuccessfully: "Errore nella verifica dell'e-mail, token non valido"
  }
}
